import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {
  // setCalculating,
  // startGetDefaultTemplate,
  startGetUserTemplates,
  startGetOfficialTopics,
  setCalculatingCountry,
  setCalculating,
  startLoadingCalculations,
} from '../../actions';

import SelectCalculationDataModal from './select-calculation-data-modal';

import {
  Card,
  PreviewCard,
  Modal
} from '../../components';

import {CALCULATION_URL} from '../innerURLs';

import './dashboard.css';

const Dashboard = ({
  startGetUserTemplates,
  startGetOfficialTopics,
  setCalculatingCountry,
  setCalculating,
  startLoadingCalculations,
  calculationStatus,
  calculationList,
  userTemplates, // just o load...

  history
})=>{

  // const country1={
  //   country:'United-States',
  //   categories:[
  //     {name: 'Category 1', percent: 30},
  //     {name: 'Category 2', percent: 58},
  //     {name: 'Category 3', percent: 95},
  //   ]
  // }

  const [isOpen,setIsOpen]=useState(false);

  useEffect(()=>{
    startGetOfficialTopics(true);

    if(!userTemplates.length) {
      startGetUserTemplates();
    }

    if(!calculationList.length) {
      startLoadingCalculations();
    }
  },[]);


  const onCancel=()=>{
    setIsOpen(false);
  }

  const setCalcData=(fnc)=>{
    if(fnc==='save') {
      return ({template,country})=>{
        // console.log('SETTING TEMPLATE FOR CALC:::',country);
        setCalculating(template);
        setCalculatingCountry(country);
        
        // template.country=country; // for the action below
        // startLoadingCalculatingTopicData(template);
        history.push(CALCULATION_URL);
      }
    }
    setIsOpen(true);
  }

  // Click a calc to see full analysis
  // const onClickCalc=(template)=>{
  //   return ()=>{
  //     setCalculatingCountry([template.country]);
  //     setCalculating(template);
  //     history.push(CALCULATION_URL);
  //   }
  // }


  // Modal to set data to make a new calculation:
  // only if there is at least 1 user template
  let modalSetDataToCalc;
  if(userTemplates.length) {
    modalSetDataToCalc=<SelectCalculationDataModal isOpen={isOpen} onCancel={onCancel} onSave={setCalcData('save')} />
  } else {
    modalSetDataToCalc=(
      <Modal isOpen={isOpen} onClose={onCancel} className="modal-content-default select-calculation-data-modal-no-template">
        <div className="font-color2">
          <h2>You haven’t created your master calculator yet. <span className="notice1">In order to make a new calculation you will need a template.</span></h2>
          <Link to="/templates" className="btn btn-default1">Create Template</Link>
        </div>
      </Modal>
    )
  }



  // Welcome card (no calculations)
  let welcome=false;
  if(calculationStatus === 'loading') {
    welcome=<h2>Loading calculations...</h2>
  } else if(!calculationList.length) {
    welcome=(
      <Card className="dashboard-header font-color2">
        <div>
          <h1>International Market Fit Calculator</h1>
          <h3>We developed this calculator to help you choose the best market for your international expansion</h3>
          <div className="flex-center">
            <button type="button" onClick={setCalcData} className="btn btn-default1">Get Started</button>
            <Link className="btn btn-default1-reverse btn-default1-reverse--dashed" to="/templates">Templates</Link>
          </div>
        </div>
      </Card>
    )
  }

  // Display of calculations
  let calcDisplay=false;
  if(calculationList.length) {
    const calcsHtml=calculationList.map((elem,index)=><PreviewCard key={'preview-card-'+index} calc={elem} />);
    calcDisplay=(
      <div className="dashboard-main">
        <div className="dashboard-calculation-display">
          {calcsHtml}
        </div>
        <div className="dashboard-main-controls">
          <button type="button" onClick={setCalcData} className="btn btn-default1-reverse btn-default1-reverse--dashed">New Calculation</button>
        </div>
      </div>
    )
  }

  return (
    <div className="background-default1 page-content">
      {modalSetDataToCalc}
      <h2 className="page-title">Dashboard</h2>
      {welcome}
      {calcDisplay}
    </div>
  )
}


const mapState2Props = ({calculation,template})=>({
  calculationStatus: calculation.calculationStatus,
  calculationList: calculation.calculationList,
  userTemplates: template.userTemplates,
});

const mapDispatch2Props=(dispatch)=>({
  startGetOfficialTopics: (checkUpdate)=>dispatch(startGetOfficialTopics(checkUpdate)),
  startGetUserTemplates: (checkUpdate)=>dispatch(startGetUserTemplates(checkUpdate)),
  setCalculatingCountry: (countryData)=>dispatch(setCalculatingCountry(countryData)),
  setCalculating: (template)=>dispatch(setCalculating(template)),
  startLoadingCalculations: ()=>dispatch(startLoadingCalculations())
});


export default connect(mapState2Props,mapDispatch2Props)(Dashboard);